<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Reply</h3>
    </div>
  </div>
  <div class="margin-0 card-body navi-hover" [perfectScrollbar]="{ wheelPropagation: false }">
    <div *ngIf="item">
      <form class="form" [formGroup]="form">
        <div class="col kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="INBOX.MESSAGE">Message</mat-label>
            <textarea matInput formControlName="body" rows="20"></textarea>
          </mat-form-field>
        </div>
        <div class="col kt-margin-bottom-20-mobile">
          <mat-label class="mr-3">{{ 'EMAIL_FAX.ATTACHMENTS' | translate }}</mat-label>
          <input type="hidden" formControlName="attachments" />
          <input #fileInput type="file" (change)="onFileChange($event)" multiple />
          <i class="flaticon2-cross" *ngIf="files.length > 0" (click)="resetFileInput()"></i>
        </div>
      </form>
      <kt-custom-progress-bar
        *ngIf="showFileLoader | async"
        [requests]="uploadRequests"
        [totalFileSize]="totalFileSize"
        (callback)="callbackOnFileLoad()"
      ></kt-custom-progress-bar>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          class="mr-2"
          mat-raised-button
          color="primary"
          (click)="reply('REPLY')"
          translate="INBOX.REPLY"
        >
          Reply
        </button>
        <button
          class="mr-2"
          mat-raised-button
          color="primary"
          (click)="reply('REPLY_ALL')"
          translate="INBOX.REPLY_ALL"
        >
          Reply to all
        </button>
        <button mat-button mat-dialog-close>Cancel</button>
      </div>
    </div>
  </div>
</div>
